// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JX5cnysgd1u51SRjjaHy{margin-bottom:10px;margin-top:15px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"additionalQuestionsHeading": `JX5cnysgd1u51SRjjaHy`
};
module.exports = ___CSS_LOADER_EXPORT___;
